import { RealtyHomeScreenContent } from "../../features/realtyList";

// RealtyHomeScreen — route landing for /feed.
//
// R2 routing decision (already settled):
//   /feed      → realty home feed (temporary)
//   /          → ProfileScreen (unchanged during R2 stabilization)
//   later      → /  flips to feed
//
// Substrate: canonical .content #Csection envelope from
// modernize.css (see design/index.html `<main class="content
// nav-top" id="Csection">`). The .container/.row layout lives
// INSIDE the feature widget.

function RealtyHomeScreen() {
  return (
    <main className="content nav-top" id="Csection" tabIndex="-1">
      <RealtyHomeScreenContent />
    </main>
  );
}

export default RealtyHomeScreen;
